

export const ConfirmEmailComponent = () =>{
    return <>
    <h1>Ждем подтверждения почты!</h1>
    </>
}